import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, TextField, MenuItem, InputAdornment } from '@material-ui/core';
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http';
import { roleInfo } from '../../../common/common';
import { getObjByName } from '../../../common/utils';

const Root = styled(Box)({
    width: '405px',
    padding: '26px',
    '& .title': {
        color: '#9B9B9B',
        fontSize: '14px',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#D8D8D8',
        margin: '16px 0',
    },
    '& .textField': {
        width: '100%',
        margin: '10px 0',
    },
    '& .footer': {
        width: '353px',
        position: 'absolute',
        bottom: '25px',
        '& .btn': {
            width: '100%',
            marginTop: '18px',
        },
    },
})

class SideList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start_salary: "",
            end_salary: "",
            office: "",
            department: "",
            team: "",
            officeData: [],
            departmentsData: [],
            teamsData: [],
            totalDOTData: []
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleApply = this.handleApply.bind(this);
    }
    render() {
        const {
            start_salary,
            end_salary,
            office,
            department,
            team,
            officeData,
            departmentsData,
            teamsData
        } = this.state;
        const deptChoose = () => {
            if (office) {
                return <TextField
                    id="outlined-select-currency"
                    select
                    label="Choose Department"
                    className="textField"
                    value={department}
                    onChange={e => this.handleSelect(e, 'department')}
                    margin="dense"
                    variant="outlined"
                >
                    {departmentsData.map(option => (
                        <MenuItem key={option.id} value={option.name}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>
            }
        }
        const teamChoose = () => {
            if (department) {
                return <TextField
                    id="outlined-select-currency"
                    select
                    label="Choose Team"
                    className="textField"
                    value={team}
                    onChange={e => this.handleSelect(e, 'team')}
                    margin="dense"
                    variant="outlined"
                >
                    {teamsData.map(option => (
                        <MenuItem key={option.id} value={option.name}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>
            }
        }
        return (
            <Root>
                <div className="filters h h-r">
                    <div>Filters</div>
                </div>
                <div className="line"></div>
                <div className="title">SALARY AMOUNT</div>
                <div className="h">
                    <TextField
                        id="outlined-select-currency"
                        className="textField"
                        value={start_salary}
                        onChange={e => this.handleChange(e, 'start_salary')}
                        margin="dense"
                        variant="outlined"
                        type="number"
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                    />
                    <div>&nbsp;&nbsp;&nbsp;&nbsp;—&nbsp;&nbsp;&nbsp;&nbsp;</div>
                    <TextField
                        id="outlined-select-currency"
                        className="textField"
                        value={end_salary}
                        onChange={e => this.handleChange(e, 'end_salary')}
                        margin="dense"
                        variant="outlined"
                        type="number"
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                    />
                </div>
                <TextField
                    id="outlined-select-currency"
                    select
                    label="Choose Office"
                    className="textField"
                    value={office}
                    onChange={e => this.handleSelect(e, 'office')}
                    margin="dense"
                    variant="outlined"
                >
                    {officeData.map(option => (
                        <MenuItem key={option.id} value={option.office}>
                            {option.office}
                        </MenuItem>
                    ))}
                </TextField>
                {deptChoose()}
                {teamChoose()}
                <div className="footer v c">
                    <div className="line"></div>
                    <Button className="btn" variant="contained" onClick={this.handleClear}>CLEAR</Button>
                    <Button className="btn" variant="contained" color="primary" onClick={this.handleApply}>APPLY FILTERS</Button>
                </div>
            </Root>
        )
    }
    componentDidMount() {
        console.log(roleInfo);
        this.getDepartments(() => {
            this.initData();
        });
    }
    initData() {
        const { data } = this.props;
        console.log(data);
        if (data) {
            const start_salary = data.start_salary;
            const end_salary = data.end_salary;
            const office = data.office;
            const department = data.department;
            const team = data.team;
            this.setNextData("office", office, () => {
                this.setNextData("department", department, () => {
                    this.setState(() => ({
                        team
                    }));
                })
            })
            this.setState(() => ({
                start_salary,
                end_salary,
                office,
                department,
                team,
            }));
        }
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        const { totalDOTData } = this.state;
        if (name === "office") {
            //1.清理department、team数据 2.根据office的name在整个data中查找dept的obj
            this.clearSelectData("department");
            const departmentsData = this.filterObjArr(totalDOTData, name, value);
            this.setState(() => ({
                departmentsData
            }));
        } else if (name === "department") {
            //1.清理team数据 2.根据dept的name在整个data中查找dept的obj 3.根据deptid获取team
            this.clearSelectData("team");
            const departmentObj = getObjByName(totalDOTData, "name", value);
            this.getTeams(departmentObj.id);
        }
        this.setState(() => ({
            [name]: value
        }))
    }
    handleClear() {
        this.clearData();
    }
    handleApply() {
        const {
            start_salary,
            end_salary,
            office,
            department,
            team
        } = this.state;
        let obj = {
            start_salary: parseFloat(start_salary),
            end_salary: parseFloat(end_salary),
            office,
            department,
            team
        };
        this.props.handleApply(obj);
    }
    //对象数组去重
    deduplicationObjArr(objArr, key) {
        const newMap = new Map();
        const deduplicationObjArr = objArr.filter((obj) => !newMap.has(obj[key]) && newMap.set(obj[key], 1));
        const arr = this.filterArr(deduplicationObjArr)
        return arr
    }
    filterArr(data) {
        let arr = []
        for (const obj of data) {
            if (obj.office !== null && obj.office !== "") {
                arr.push(obj)
            }
        }
        return arr;
    }
    //对象数组过滤出相同的obj
    filterObjArr(objArr, key, name) {
        let newObjArr = [];
        for (const obj of objArr) {
            if (obj[key] === name) {
                newObjArr.push(obj);
            }
        }
        return newObjArr
    }
    setNextData(name, value, callback = null) {
        const { totalDOTData } = this.state;
        if (name === "office") {
            //1.清理department、team数据 2.根据office的name在整个data中查找dept的obj
            this.clearSelectData("department");
            const departmentsData = this.filterObjArr(totalDOTData, name, value);
            this.setState({
                departmentsData
            }, () => {
                if (callback) callback();
            });
        } else if (name === "department") {
            //1.清理team数据 2.根据dept的name在整个data中查找dept的obj 3.根据deptid获取team
            this.clearSelectData("team");
            const departmentObj = getObjByName(totalDOTData, "name", value);
            if (departmentObj) {
                this.getTeams(departmentObj.id, () => {
                    if (callback) callback();
                });
            }
        }
    }
    clearSelectData(name) {
        if (name === "team") {
            this.setState(() => ({
                team: "",
                teamsData: [],
            }))
        } else if (name === "department") {
            this.setState(() => ({
                department: "",
                team: "",
                teamsData: [],
            }))
        }
    }
    clearData() {
        this.setState(() => ({
            start_salary: "",
            end_salary: "",
            office: "",
            department: "",
            team: "",
            departmentsData: [],
            teamsData: [],
        }))
    }
    //-------------request------------------------
    getDepartments(callback = null) {
        instance.get(BASE_URL + 'common/departments').then((res) => {
            let totalDOTData = res.data.data;
            let officeData = this.deduplicationObjArr(totalDOTData, "office")
            //过滤出重复office
            this.setState(() => ({
                totalDOTData,
                officeData
            }))
            console.log("totalDOTData", totalDOTData)
            if (callback) callback()
        })
    }
    getTeams(dept_id, callback = null) {
        const params = {
            dept_id
        }
        instance.get(BASE_URL + 'admin/teams', { params }).then((res) => {
            const teamsData = res.data.data;
            this.setState({
                teamsData
            }, () => {
                if (callback) callback();
            });
        })
    }
}

export default SideList;